import React, { createContext } from 'react';

import { MockedAuthProvider } from './MockedAuthProvider';
import { StandardAuthProvider } from './StandardAuthProvider';

const AuthContext = createContext();

const AuthProvider = (props) => {
  const { useMocks } = props;

  if (useMocks && JSON.parse(useMocks)) {
    return <MockedAuthProvider {...props} AuthContext={AuthContext} />;
  } else {
    return <StandardAuthProvider {...props} AuthContext={AuthContext} />;
  }
};

export { AuthContext, AuthProvider };
